import { Component, inject, OnInit, signal } from "@angular/core";
import { MessageService } from "../message.service";
import { LocalStorageService } from "../../../../local-storage/local-storage.service";
import { ButtonAction } from "../../../../services/base-http.service";

@Component({
  standalone: false,
  selector: 'app-error-modal',
  templateUrl: './error-modal.component.html',
  styleUrls: ['./modal.component.css']
})
export class ErrorModalComponent implements OnInit {
  private readonly messageService = inject(MessageService);
  private readonly localStorageService = inject(LocalStorageService);

  readonly currentErrorMessage = this.messageService.currentErrorMessage;
  appColor: string;
  readonly processing = signal(false);

  ngOnInit(): void {
    this.appColor = this.localStorageService.get("app_color");
  }

  hideMessage(): void {
    this.messageService.hideErrorMessage();
  }

  buttonClicked() {
    this.anyButtonClicked(this.currentErrorMessage().errorObject.buttonAction);
  }

  secondaryButtonClicked() {
    this.anyButtonClicked(this.currentErrorMessage().errorObject.secondaryButtonAction);
  }

  private anyButtonClicked(action: ButtonAction) {
    this.processing.set(true);
    if (action === "CLOSE") {
      this.hideMessage();
    } else {
      this.messageService.actionButtonClicked(action);
    }
    setTimeout(() => {
      this.processing.set(false);
    }, 3000);
  }
}
